export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  // 如果已经是 YYYY-MM 格式就直接返回
  if (/^\d{4}-\d{2}$/.test(dateString)) {
    return dateString;
  }
  
  try {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  } catch (error) {
    return dateString;
  }
}; 